import { Product, VariationGroup } from 'editor/src/store/variants/types';

// Finds a human-readable label for a spread-count partition header.
// We can't use group.title directly — it contains ALL controls joined
// (e.g. "Vertical - 14.1x14.1 cm - Printed on one side"), but we need
// only the part that distinguishes this partition from others (e.g. just
// "Printed on one side"). This scans product controls to find the first
// value that's uniform within this partition AND absent from others.
// For flyers this resolves to the color-type control ("Printed on one side"
// vs "Printed on both sides"). Generic so it works for any future product
// where spread count differences correlate with a product control.
function getPartitionLabel(
  partition: VariationGroup[],
  otherPartitions: VariationGroup[][],
  product: Product,
): string {
  const firstVariant = partition[0]?.variationsInfo[0];
  if (!firstVariant) return '';

  const controls = product.groupBy.length
    ? product.groupBy
        .map((key) => product.productControls.find((c) => c.key === key))
        .filter((c): c is NonNullable<typeof c> => !!c)
    : product.productControls;

  for (const control of controls) {
    const thisValue = firstVariant.variation[control.key];
    const allSameInPartition = partition.every((g) =>
      g.variationsInfo.every((v) => v.variation[control.key] === thisValue),
    );
    if (!allSameInPartition) continue;

    const differFromOthers = otherPartitions.every((otherPartition) =>
      otherPartition.some((g) => g.variationsInfo.some((v) => v.variation[control.key] !== thisValue)),
    );
    if (!differFromOthers) continue;

    const optionTitle = control.options.find((o) => o.value === thisValue)?.title;
    if (optionTitle) return optionTitle;
  }

  return partition[0]?.title || '';
}

export default getPartitionLabel;
